import { UAParser } from "ua-parser-js";

export const parseUserAgent = () => {
  const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
  return new UAParser(userAgent).getResult();
};

export const isSafari = (): boolean => {
  const name = parseUserAgent().browser.name;
  return name === "Safari" || name === "Mobile Safari";
};

export const isMobileSafari = (): boolean => {
  const { browser, os } = parseUserAgent();
  return browser.name === "Mobile Safari" || (os.name === "iOS" && browser.name === "Safari");
};

export const isIOS = (): boolean => parseUserAgent().os.name === "iOS";

export const isIPadOs = (): boolean =>
  typeof navigator !== "undefined" && navigator.maxTouchPoints > 1 && parseUserAgent().os.name === "macOS";

export const isAndroid = (): boolean => parseUserAgent().os.name === "Android";

export const isMobile = (): boolean => {
  const type = parseUserAgent().device.type;
  return type === "mobile" || type === "tablet";
};

export const isMobilePhone = (): boolean => parseUserAgent().device.type === "mobile";
